var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_23159)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7146 5.294C24.0976 5.66829 24.3733 6.13426 24.5143 6.64534C25.0223 8.52608 25.0284 12.4524 25.0284 12.4524C25.0284 12.4524 25.0284 16.3787 24.5143 18.2594C24.3733 18.7705 24.0976 19.2365 23.7146 19.6108C23.3316 19.9851 22.8548 20.2546 22.3319 20.3924C20.4075 20.8968 12.6856 20.8968 12.6856 20.8968C12.6856 20.8968 4.96575 20.8968 3.04137 20.3924C2.51824 20.2549 2.04126 19.9855 1.65823 19.6112C1.27519 19.2368 0.999545 18.7707 0.85892 18.2594C0.342773 16.3787 0.342773 12.4524 0.342773 12.4524C0.342773 12.4524 0.342773 8.52608 0.85892 6.64534C0.998299 6.13261 1.27339 5.6648 1.65651 5.28898C2.03963 4.91315 2.51727 4.64257 3.04137 4.50444C4.96372 4 12.6856 4 12.6856 4C12.6856 4 20.4055 4 22.3319 4.51239C22.8548 4.65019 23.3316 4.9197 23.7146 5.294ZM16.6312 12.4518L10.216 16.0703V8.83333L16.6312 12.4518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_23159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6857,
    height: 24,
    fill: "white",
    transform: "translate(0.342773)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.407c2413443bdbfd73e9c6a8656c0efe.svg";
export { ForwardRef as ReactComponent };